import { DataGrid, GridRowsProp, GridColDef } from "@mui/x-data-grid";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { BsXCircle } from "react-icons/bs";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "../../assets/css/main.css";
import { DAILY, MONTHLY, WEEKLY } from "../../common/constant";
import {
  customStyles,
  headerContainerStyle,
  headerStyle,
  iconStyle,
  selectStyle,
  titleStyle,
} from "../../common/resultDetailStyle";
import {
  addDayToTimeNow,
  convertDateToString,
  getFirstDayOfMonth,
  getFirstDayOfWeek,
  getLastDayOfWeek,
  isNotNull,
} from "../../common/utils";
import { restGetApi, restPostApi } from "../../services/httpService";
import {
  buyTurnConfirmUrl,
  loadMonthlyResultUrl,
  loadResultUrl,
} from "../../common/url";
import { useSelector } from "react-redux";
import { error, httpSuccess, success } from "../../common/errorCode";
import { store } from "../..";
import { setDataToModal } from "../../actions/modal";
import iphone from "../../assets/img/iphone.png";
import ResultWinner from "./ResultWinner";
import { useTranslation } from "react-i18next";

const colourStyles = {
  // menuList: styles => ({
  //     ...styles,
  //     background: 'white',
  // }),
  // option: (styles, { isFocused, isSelected }) => ({
  //     ...styles,
  //     background: isFocused
  //         ? 'hsla(291, 64%, 42%, 0.5)'
  //         : isSelected
  //             ? 'hsla(291, 64%, 42%, 1)'
  //             : undefined,
  //     zIndex: 1,
  // }),
  // menu: base => ({
  //     ...base,
  //     zIndex: 100,
  //     background: "black"
  // }),
};

const ResultDetail = ({ typeResult, isOpenOtp, setOpenOtp }) => {
  const [selectData, setSelectData] = useState("");
  const tokenInfo = useSelector((state) => state.SessionReducer);
  const [rows, setRows] = useState([]);
  const [isShowWinner, setIsShowWinner] = useState(false);
  const [prizeInfo, setPrizeInfo] = useState(0);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const { t } = useTranslation();

  let options = [];
  // const rows = [
  // { id: 1, col1: 'Hello', col2: 'World', col3: 'wer', col4: 'wetefer' },
  // { id: 2, col1: 'DataGridPro', col2: 'is Awesome', col3: 'erherhw', col4: 'gergreg' },
  // { id: 3, col1: 'MUI', col2: 'is Amazing', col3: 'gwgewgwegwe', col4: 'gwege' },
  // ];

  const { innerWidth: width, innerHeight: height } = window;

  // console.log("windowWidth: " + width);ß

  let col1Width = (width - 20) * 0.4;
  let col2Width = (width - 20) * 0.4;
  let col3Width = (width - 20) * 0.4;
  let col4Width = (width - 20) * 0.4;

  const columns = [
    { field: "col1", headerName: t("date"), width: col1Width },
    { field: "col2", headerName: t("time"), width: col2Width },
    { field: "col3", headerName: t("phoneNo"), width: col3Width },
    { field: "col4", headerName: t("prize"), width: col4Width },
  ];

  useEffect(() => {
    // load data for first
    console.log("isOpenOtp: " + isOpenOtp);
    console.log("typeResult: " + typeResult);

    if (isOpenOtp && typeResult === DAILY) {
      loadResult();
    } else if (isOpenOtp && typeResult === MONTHLY) {
      loadResult(-1);
    }
    if (isOpenOtp && typeResult === WEEKLY) {
      loadResult();
    }
  }, []);

  // get data
  if (typeResult === DAILY) {
    options = [
      { value: "0", label: convertDateToString(addDayToTimeNow(0)) },
      { value: "-1", label: convertDateToString(addDayToTimeNow(-1)) },
      { value: "-2", label: convertDateToString(addDayToTimeNow(-2)) },
    ];
  } else if (typeResult === WEEKLY) {
    options = [
      { value: "0", label: getFirstDayOfWeek(0) + " - " + getLastDayOfWeek(0) },
      {
        value: "-1",
        label: getFirstDayOfWeek(-1) + " - " + getLastDayOfWeek(-1),
      },
      {
        value: "-2",
        label: getFirstDayOfWeek(-2) + " - " + getLastDayOfWeek(-2),
      },
    ];
  } else {
    options = [
      { value: "-1", label: getFirstDayOfMonth(-1) },
      { value: "-2", label: getFirstDayOfMonth(-2) },
      { value: "-3", label: getFirstDayOfMonth(-3) },
    ];
  }

  function convertKeyToValue(key) {
    return convertDateToString(addDayToTimeNow(key));
  }

  function chooseTimeClick(value) {
    console.log("value choose: " + value);
    // setSelectData(value);
    loadResult(value);
  }

  async function loadResult(value) {
    console.log("value choose loadResult: " + value);
    let dayAdd = isNotNull(value) ? value : 0;
    let res = await restPostApi(
      typeResult === MONTHLY ? loadMonthlyResultUrl : loadResultUrl,
      {
        pageNumber: 0,
        pageSize: 10,
        type: typeResult,
        fromTime:
          typeResult === DAILY
            ? convertKeyToValue(dayAdd) + " 00:00:00"
            : typeResult === WEEKLY
            ? getFirstDayOfWeek(0) + " 00:00:00"
            : "01/" + getFirstDayOfMonth(dayAdd * 1) + " 00:00:00",
        toTime:
          typeResult === DAILY
            ? convertKeyToValue(dayAdd * 1 + 1) + " 00:00:00"
            : typeResult === WEEKLY
            ? getLastDayOfWeek(dayAdd * 1 + 1) + " 00:00:00"
            : "01/" + getFirstDayOfMonth(dayAdd * 1 + 1) + " 00:00:00",
      },
      tokenInfo
    );

    console.log("res: " + JSON.stringify(res));

    let message = "";
    let errorCode = error;

    if (res != null) {
      console.log("status: " + res.status);

      if (res.status === httpSuccess) {
        console.log("errorCode: " + res.data.errorCode);
        errorCode = res.data.errorCode;
        if (res.data.errorCode === success) {
          console.log("typeResult: " + typeResult);
          if (typeResult === DAILY || typeResult === WEEKLY) {
            let dataSets = res.data.data.dataSets;
            let rowSet = [];
            if (isNotNull(dataSets) && dataSets.length > 0) {
              for (let i = 0; i < dataSets.length; i++) {
                rowSet.push({
                  id: i + 1,
                  col1: dataSets[i].date,
                  col2: dataSets[i].fromTime + " - " + dataSets[i].toTime,
                  col3: dataSets[i].msisdn,
                  col4: dataSets[i].prize,
                });
              }
            } else {
            }
            setRows(rowSet);
          } else if (typeResult == MONTHLY) {
            console.log("month result");
            let winnerCodes = res.data.data.winnerCodes;
            let prizes = res.data.data.prizes;

            console.log("winnerCodes: " + JSON.stringify(winnerCodes));
            console.log("prizes: " + JSON.stringify(prizes));

            let rowSet = [];
            if (isNotNull(prizes) && prizes.length > 0) {
              // rowSet = prizes;
              console.log("rowSet: " + JSON.stringify(rowSet));

              for (let i = 0; i < prizes.length; i++) {
                // get code
                let winner = winnerCodes.find(
                  (x) => x.prizeId === prizes[i].id
                );
                rowSet.push({
                  id: prizes[i].id,
                  name: prizes[i].name,
                  image: prizes[i].image,
                  priority: prizes[i].priority,
                  code: isNotNull(winner) ? winner.code : null,
                  type: prizes[i].type,
                  winnerCodeId: isNotNull(winner) ? winner.winnerCodeId : null,
                });
              }
            }
            setRows(rowSet);
          }
          return;
        } else {
          console.log("message: " + res.data.message);
          message = res.data.message;
          setRows([]);
        }
      } else {
        console.log("message: " + res.data);
        message = res.data;
        setRows([]);
      }
    } else {
      console.log("message: Exception");
      message = "Exception";
    }
    // store.dispatch(setDataToModal({
    //     type: 'result',
    //     dataToModal: {
    //         errorCode: errorCode,
    //         message: message
    //     }
    // }));
  }

  function monthlyPrizeClick(value) {
    console.log("monthlyPrizeClick : " + value);
    setIsShowWinner(true);
    setPrizeInfo(value);
    setModalIsOpen(!modalIsOpen);
  }

  return (
    <div>
      <Modal
        isOpen={isOpenOtp}
        onRequestClose={setOpenOtp}
        style={customStyles}
        contentLabel="Result detail Modal"
      >
        <div style={headerContainerStyle}>
          <div style={iconStyle} onClick={setOpenOtp}>
            <BsXCircle style={{ height: "2rem", width: "2rem" }} />
          </div>
        </div>
        <div style={titleStyle}>
          <div style={headerStyle}>
            <div style={{ padding: "10px 0px" }}>
              {typeResult === MONTHLY
                ? t("monthlyPrize")
                : typeResult === WEEKLY
                ? t("weeklyPrize")
                : t("dailyPrize")}
            </div>
          </div>
        </div>
        <div style={selectStyle}>
          <Select
            options={options}
            styles={colourStyles}
            onChange={(e) => chooseTimeClick(e.value)}
          />
        </div>
        {typeResult === MONTHLY ? (
          (() => {
            let dataRender = [];
            for (let i = 0; i < rows.length; i++) {
              // get code
              let winnerCode = dataRender.push(
                <div
                  id={i}
                  className="row ticket-container"
                  onClick={() => monthlyPrizeClick(rows[i])}
                >
                  <div className="col-4 ticket-left">
                    <div className="ordinal">{rows[i].priority + 1}</div>
                    <div className="ordinal-des">ST</div>
                    <div className="prize">
                      {/* <img src={iphone} /> */}
                      <img src={"../assets/images/" + rows[i].image} />
                      <p>{rows[i].name}</p>
                    </div>
                  </div>
                  <div className="col-8 ticket-right">
                    {(() => {
                      let codeRender = [];
                      if (isNotNull(rows[i].code)) {
                        let listChar = rows[i].code.split("");
                        for (let l = 0; l < listChar.length; l++) {
                          codeRender.push(
                            <div className="ticket-number">{listChar[l]}</div>
                          );
                        }
                      } else {
                        for (let l = 0; l < 6; l++) {
                          codeRender.push(
                            <div className="ticket-number">{"?"}</div>
                          );
                        }
                      }
                      return codeRender;
                    })()}
                  </div>
                </div>
              );
            }
            return dataRender;
          })()
        ) : (
          <DataGrid
            id={typeResult}
            disableColumnMenu
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            style={{ color: "white", border: "none" }}
            sx={{
              color: "white",
              "& .MuiDataGrid-cell:hover": {
                color: "white",
              },
              "& .MuiTablePagination-displayedRows": {
                color: "white",
              },
              "& .MuiButtonBase-root": {
                color: "white !important",
              },
            }}
          />
        )}
      </Modal>
      {isShowWinner ? (
        <ResultWinner
          prizeInfo={prizeInfo}
          isOpenModal={modalIsOpen}
          setIsOpenModal={setModalIsOpen}
        />
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default ResultDetail;
